// @tennis-matches/core/utils/courtColor
// Court color utility for applying CSS custom properties
// Used by both apps/web and apps/schleifchen

/**
 * Applies court color to CSS custom properties.
 * @param {"orange"|"blue"|string} color
 */
export function applyCourtColor(color) {
  const root = document.documentElement;

  if (color === "orange") {
    // Sand/Orange court colors
    root.style.setProperty("--court-bg", "#fff3e0");
    root.style.setProperty("--court-bg-light", "#ffe0b2");
    root.style.setProperty("--court-border", "#e65100");
    root.style.setProperty("--court-line", "#bf360c");
    // Status colors based on orange
    root.style.setProperty("--court-status-current-border", "rgba(230, 81, 0, 0.5)");
    root.style.setProperty("--court-status-current-bg", "rgba(230, 81, 0, 0.12)");
    root.style.setProperty("--court-status-current-shadow", "rgba(230, 81, 0, 0.15)");
    root.style.setProperty("--court-status-result-bg", "rgba(230, 81, 0, 0.1)");
    root.style.setProperty("--court-status-result-color", "rgba(230, 81, 0, 0.9)");
  } else {
    // Blue/Indoor court colors (default)
    root.style.setProperty("--court-bg", "#e3f2fd");
    root.style.setProperty("--court-bg-light", "#bbdefb");
    root.style.setProperty("--court-border", "#1976d2");
    root.style.setProperty("--court-line", "#1565c0");
    // Status colors based on blue
    root.style.setProperty("--court-status-current-border", "rgba(25, 118, 210, 0.5)");
    root.style.setProperty("--court-status-current-bg", "rgba(25, 118, 210, 0.12)");
    root.style.setProperty("--court-status-current-shadow", "rgba(25, 118, 210, 0.15)");
    root.style.setProperty("--court-status-result-bg", "rgba(25, 118, 210, 0.1)");
    root.style.setProperty("--court-status-result-color", "rgba(25, 118, 210, 0.9)");
  }
}
